import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const registerEmailEffect = (data) => {
  return axiosInstance.request({
    url: `${API.CARRIER_EMAIL_REGISTRATION}/RegisterEmail`,
    method: 'post',
    data,
  });
};

export const getRegisterEmailEffect = (payload) => {
  const { carrierKey } = payload;
  return axiosInstance.request({
    url: `${API.CARRIER_EMAIL_REGISTRATION}/GetRegisterEmailsByCarrier`,
    method: 'get',
    params: {
      carrierKey,
    },
  });
};

export const deactivateRegisterEmailEffect = (data) => {
  return axiosInstance.request({
    url: `${API.CARRIER_EMAIL_REGISTRATION}/DeactivateRegisterCarrierEmails`,
    method: 'post',
    data,
  });
};
